import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { auth } from '../../config/firebase';
import { setupWebNotifications } from '../../services/notificationsService';

const NotificationProvider = ({ children }) => {
  const location = useLocation();
  const servicioId = location.state?.servicioId;

  useEffect(() => {
    if (auth.currentUser && servicioId) {
      setupWebNotifications(servicioId, auth.currentUser.email);
    }
  }, [auth.currentUser, servicioId]);

  return children;
};

export default NotificationProvider;